<script>
export default {
    props: {
        buttonClasses: {
            type: String,
            default: ''
        },
        buttonType: {
            type: String,
            default: 'button'
        },
        duskSelector: {
            type: String,
            default: ''
        },

    }
}
</script>

<template>
    <button
        class="py-2 px-4 leading-5 text-gray-900 uppercase bg-rss-grayblue-100 hover:bg-rss-grayblue-50 rounded-full focus:outline-none focus:ring focus:ring-rss-blue-300 hover:shadow-lg disabled:opacity-75 transition duration-300 ease-in-out"
        :class="buttonClasses"
        :type="buttonType"
        :dusk="duskSelector"
    >
        <slot />
    </button>
</template>
